export const blockIconsSocialEcoNew = (
	<span className='material-symbols-outlined'>eco</span>
);
